module.exports = __webpack_public_path__ + "static/media/ensaladasyaderezos.4a612d69.svg";